<template>
<div class="chapter">
<div class="inner_page">
<p class="tiph"><a id="page_23"><span class="txbf">TIPS FOR STAYING ORGANIZED</span></a></p><a id="page_23">
<hr class="hr"/>
<p class="noindentlb">When you can’t find something you need or aren’t sure where to begin and what to prioritize, you can’t possibly be productive. Keeping even a little bit of organization in your life will go a long way toward your success. Here are some easy ways to stay organized:</p>
<p class="number1">39. Don’t let things pile up. If you’re putting off tasks, find a way to either tackle them ASAP or pass them along to someone else who can.</p>
<p class="number1">40. File paperwork as soon as you can. The more you let things accumulate on your desk, the harder it will be to get organized (or find certain papers) later on.</p>
<p class="number1">41. Keep a donation box tucked away in a closet at home where you and other family members can drop things that you know you no longer need.</p>
<p class="number1">42. Clean out your fridge weekly to make sure you don’t have expired food hanging around. You don’t want to plan on a breakfast with that bottle of OJ, only to discover it expired last month!</p>
<p class="number1">43. Before your kids go to bed at night, hold a “race” to see who can pick up and put away the most out-of-place stuff (e.g., toys and stray shoes) the fastest.</p>
</a><p class="number1"><a id="page_23">44. </a><a id="page_24">Organize your closet by occasion rather than item. When all your formal wear is together, it will be easier to find something for that big night out.</a></p><a id="page_24">
<p class="number1">45. If something is broken and you don’t have immediate plans to fix it, get rid of it. Don’t keep things because you might repair them “one day.”</p>
<p class="number1">46. If you have a lot to organize, start small, like organizing one desk drawer at a time. By the end of the week you will have an organized desk and will be ready to tackle that bookshelf.</p>
<p class="number1">47. Store things you use ten times a year or less in long-term storage like a garage or remote closet. Don’t give those items prime real estate in your home!</p>
<p class="number1">48. Use hanging shoe organizers that go over the back of doors to organize office supplies, cables, and more.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01d.vue?6001ecfc